import { Box, FormControl, Grid, InputLabel, Slider } from '@mui/material'
import { Typography } from '@carto/meridian-ds/components'
import { useAppSelector } from 'app/state'
import { RequestStatus } from 'features/common'
import { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { FilterByColumnSettings } from '../../types'
import InputNumber from './InputNumber'

function LessThan({
  filterSettings,
  onChange
}: {
  filterSettings: FilterByColumnSettings
  onChange: (filterSettings: FilterByColumnSettings) => void
}) {
  const [number, setNumber] = useState(filterSettings?.filterNumberFirst)
  const columnStats = useAppSelector((state) => state.analysis.columnStats)
  const columnStatsStatus = useAppSelector((state) => state.analysis.columnStatsStatus)
  const max = columnStats?.max
  const min = columnStats?.min

  const handleChange = (e, newValue) => {
    setNumber(newValue)
    const newState = { ...filterSettings, filterNumberFirst: newValue }
    onChange(newState)
  }

  return (
    <FormControl size="small" margin="normal">
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <InputLabel id={`analysis-numbers-slide-label`} variant="outlined">
            <FormattedMessage id="analysis.columnValue.numberFilter.input.slide" />
          </InputLabel>
          <Box ml={1} mr={0.5}>
            <Slider
              min={min}
              max={max}
              name="analysis-numbers-slide-less-label"
              disabled={columnStatsStatus === RequestStatus.Pending}
              value={number || 0}
              onChange={handleChange}
            />
          </Box>
        </Grid>
        <Grid container spacing={1} justifyContent="space-between" ml={0.5}>
          <Grid item xs={3} style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
            <Typography variant="caption" color="textSecondary">
              <FormattedMessage id="analysis.columnValue.numberFilter.input.min" />
              <strong> {min}</strong>
            </Typography>
          </Grid>
          <Grid item xs={4}>
            <InputNumber
              number={number}
              adornment="<"
              onChange={(value) => {
                setNumber(value)
                onChange({ ...filterSettings, filterNumberFirst: value })
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </FormControl>
  )
}

export default LessThan
